export var VERSION = '2.30.1';
//# sourceMappingURL=version.js.map